// Stable per-user color: hash the userId to a hue on the full HSL wheel so each
// monitor keeps the same color across reloads and the palette never runs out —
// every monitor is distinct regardless of how many there are. Fixed saturation
// and lightness keep it legible with white text in both light and dark mode.
// Shared by the calendar blocks, the resource-row avatars, and the on-duty strip
// so a monitor's identity color is consistent everywhere.
export function colorForUser(userId: string): string {
  let hash = 0;
  for (let i = 0; i < userId.length; i += 1) {
    hash = (hash * 31 + userId.charCodeAt(i)) >>> 0;
  }
  const hue = hash % 360;
  return `hsl(${hue}, 60%, 40%)`;
}
